import { HttpClient } from '@angular/common/http'
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
  selector: 'app-responsive-logo',
  template: `<div [ariaLabel]="ariaLabel" [innerHTML]="svgContent"></div>`,
  styleUrls: ['./responsive-logo.component.scss'],
})
export class ResponsiveLogoComponent implements OnChanges {
  @Input() path: string = ''
  @Input() ariaLabel: string = ''
  svgContent: SafeHtml = ''

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['path']) {
      this.loadSvg(this.path)
    }
  }

  private loadSvg(path: string) {
    this.http.get(path, { responseType: 'text' }).subscribe((svg) => {
      this.svgContent = this.sanitizer.bypassSecurityTrustHtml(svg)
    })
  }

  ngOnInit() {
    this.loadSvg(this.path)
  }
}
